import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { authApiInstance } from '../services/api_service';
import { ToastContainer, toast } from 'react-toastify';

const GOOGLE_SOCIAL_AUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_SOCIAL_AUTH_CLIENT_ID;

function GoogleLoginComponent() {

  const authenticationFailed = () => {
    toast.error("Você não tem autorização de acesso. Contate o administrador.", {
      position: "top-right",
      autoClose: 2500,
    });
  }

  const handleSuccess = async (credentialResponse) => {
    try {
      const payload = {credential: credentialResponse.credential};
      const response = await authApiInstance.post(
        'authentication/user/google', 
        payload, 
        {headers: {'Content-Type': 'application/json'}}
      );
      if (response === undefined) {
        authenticationFailed();
        return
      }
      console.log(`User info`, response);
      sessionStorage.clear();
      toast.success("Autenticação realizada com sucesso", {
        position: "top-right",
        autoClose: 800,
        onClose: () => window.location.replace('/')
      });
    } catch (err) {
      console.error('Failed to fetch user info');
      authenticationFailed();
      return
    } 
  };

  const handleFailure = (error) => {
      console.error("Google login failed", error);
      toast.error("Erro no login do Google. Tente novamente.", {
        position: "top-right",
        autoClose: 2500,
      });
  };

  // Callback para debug quando o Google OAuth é inicializado
  const handleScriptLoad = () => {
    console.log("Google OAuth script loaded successfully");
  };

  // Callback para debug quando há erro no carregamento
  const handleScriptError = (error) => {
    console.error("Error loading Google OAuth script:", error);
  };

  return (
    <div className={'mt-48'}>
      <ToastContainer />
      <GoogleOAuthProvider 
        clientId={GOOGLE_SOCIAL_AUTH_CLIENT_ID}
        onScriptLoadSuccess={handleScriptLoad}
        onScriptLoadError={handleScriptError}
      >
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleFailure}
            auto_select={false}
            cancel_on_tap_outside={true}
            use_fedcm_for_prompt={false}
            size="large"
            theme="outline"
            text="Entrar com Google"
            logo_alignment="left"
        />
      </GoogleOAuthProvider>
    </div>  
  );
}

export default GoogleLoginComponent;
